const axios = require('axios').default;

export default class Credentials {
  public username: string;

  public password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }

  tryLogin() {
    return axios.get(`${'https://www.screenscraper.fr/api2/ssuserInfos.php'
    + '?devid='}${this.username
    }&devpassword=${this.password
    }&softname=scrapadmin`
    + '&output=json'
    + '&ssid=scrapadmintest&sspassword=ThisIsAGreatPassword');
  }
}
